// External Dependencies
import Marionette from 'backbone.marionette';
import Backbone from 'backbone';

// Internal Dependencies - screens/views/templates
import confidentialRecordsItemView  from '../../../../templates/CCM/PatientList/confidentialRecordsItemView';

// Internal Dependencies - models/collections


export default Marionette.ItemView.extend({

	className: 'table-row clearfix',

	events: {
		'click .download-patient-triage-record': 'openRecord',
	},

	initialize: function() {
		this.channel = Backbone.Radio.channel( 'AppChannel' );
		this.app = this.channel.request( 'app' );
		this.controller = this.app.ccm_controller;
		this.listenTo( this.model, 'change', this.render );
	},

	getTemplate: function() {
		return confidentialRecordsItemView( this.model );
	},

	openRecord: function() {
		const file_type = this.model.get('file_type');
		if(file_type === 'PHS'){

		}else if(file_type === 'CONFIDENTIAL_NOTES'){
			let patientId = this.model.get( 'patient_id' );
			this.controller.openConfidentialNotes( patientId );
		}else if(file_type === 'CONFIDENTIAL_FILE'){
			this.controller.getPatientConfidentialDoc( this.model.get('patient_id'), this.model.get('id'), this.model.get('file_name') )
		}
		
	},

});
